import React from 'react';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { toUpper } from 'lodash';
import numeral from 'numeral';
import { GlobalToken } from 'antd';

import Super from '@/comp/Super';
import { useMeasurement } from '@/hooks/useMeasurement';

interface BaselineSpecificPowerTooltipProps {
  value: number;
  name: string;
  measurementSystem: string;
  token: GlobalToken;
}

const BaselineSpecificPowerTooltip = ({ value, name, measurementSystem, token }: BaselineSpecificPowerTooltipProps) => {
  const { t } = useTranslation();
  const { tunit } = useMeasurement();

  return (
    <TooltipContainer theme={{ token }}>
      <div className="title">{name}</div>

      <table>
        <tr>
          <td>
            <div className="name">{t('Specific Power')}</div>
          </td>
          <td>
            <div className="value-container">
              <span className="value">
                {toUpper(measurementSystem) === 'IMPERIAL'
                  ? numeral(value).format('0,0.0')
                  : numeral(value).format('0,0.00')}
              </span>
              <span className="label">
                <Trans i18nKey={tunit('kW/(m3/min)')}>
                  <Super />
                </Trans>
              </span>
            </div>
          </td>
        </tr>
      </table>
    </TooltipContainer>
  );
};

const TooltipContainer = styled.div<{ theme: { token: GlobalToken } }>`
  position: relative;
  padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingLG}px;
  background-color: ${({ theme: { token } }) => token.colorBgElevated};
  color: ${({ theme: { token } }) => token.colorText};
  border-radius: 4px;
  box-shadow: ${({ theme: { token } }) => token.boxShadowSecondary};

  .title {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    padding-bottom: ${({ theme: { token } }) => token.paddingXXS}px;
  }

  table {
    tr {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      padding: ${({ theme: { token } }) => token.paddingXXS}px;
      td {
        position: relative;
        padding: ${({ theme: { token } }) => `${token.paddingXXS}px ${token.paddingXS}px ${token.paddingXXS}px 0`};

        .value-container {
          .label {
            padding-left: ${({ theme: { token } }) => token.paddingXXS}px;
          }
        }
      }
    }
`;

export default BaselineSpecificPowerTooltip;
